<div class="ui modal trial-activated-modal">
  <div class="icon-wrapper">
    <svg  alt="success icon"   width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 58.667c15.832 0 28.667-12.835 28.667-28.667S45.832 1.333 30 1.333 1.333 14.168 1.333 30 14.168 58.667 30 58.667zM30 60C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30zm-5.185-20.33l19.799-19.798.942.943-19.799 19.799c-.52.52-1.365.52-1.885 0l-9.428-9.428.942-.943 9.429 9.428z" fill="#28A648"/></svg>
  </div>
  <h3>{{successCopy.heading}}</h3>
  <div class="description">
    <p>{{successCopy.description}}</p>
    <ul class="two-col-check-list">
      <li *ngFor="let feature of successCopy.featuresList;">
        {{feature}}
      </li>
    </ul>
  </div>
  <button class="ui button primary has-box-shadow close" (click)="proTrialActivate()" i18n>Close</button>
</div>